import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Toaster } from 'react-hot-toast';

import Layout from './components/Layout/Layout';
import HomePage from './pages/HomePage';
import Lb1Page from './pages/Lb1Page';
import QuizLandingPage from './pages/QuizLandingPage';
import AssessmentPage from './pages/AssessmentPage';
import ResultsPage from './pages/ResultsPage';
import { AssessmentProvider } from './contexts/AssessmentContext';
import { LocaleProvider } from './contexts/LocaleContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// TurnKeyOS.AI Brand Colors
// Primary: #32373c (dark gray - buttons/primary actions)
// Accent: #0693e3 (vivid cyan blue)
// Secondary: #00d084 (green-cyan)
const theme = createTheme({
  palette: {
    primary: {
      main: '#0693e3', // TurnKeyOS.AI vivid cyan blue
      dark: '#0578b8',
      light: '#38a5e8',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#32373c', // TurnKeyOS.AI dark gray
      light: '#4a5056',
      dark: '#1d2024',
      contrastText: '#ffffff',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#32373c',
      secondary: '#6b7280',
    },
  },
  typography: {
    fontFamily: '"Arial", "Helvetica", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      color: '#32373c',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 'bold',
      color: '#32373c',
    },
    body1: {
      fontSize: '1rem',
      color: '#32373c',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          padding: '12px 24px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LocaleProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AssessmentProvider>
            <Router>
              <Layout>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/lb1" element={<Lb1Page />} />
                  <Route path="/guide" element={<QuizLandingPage />} />
                  <Route path="/assessment/:type" element={<AssessmentPage />} />
                  <Route path="/results/:sessionId" element={<ResultsPage />} />
                </Routes>
              </Layout>
            </Router>
          </AssessmentProvider>
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#333',
                color: '#fff',
              },
            }}
          />
        </ThemeProvider>
      </LocaleProvider>
    </QueryClientProvider>
  );
}

export default App;